export enum NavTabs {
    Stream = 0,
    History = 1,
}
